import CookieDefinitions from '@amzn/shortbread/dist/definitions/cookie-definitions';

export const COOKIES = {
  regStatus: {
    cat: 'performance',
  },
  'aws-reg-aid': {
    cat: 'functional',
  },
  'awsd2c-token': {
    cat: 'functional',
  },
  'awsd2c-token-c': {
    cat: 'functional',
  },
  'aws-target-visitor-id': {
    cat: 'functional',
  },
  _mkto_trk: {
    cat: 'functional',
  },
};

export const DEFAULT_CONSENT: CookieDefinitions.ConsentCookie = {
  essential: true,
  performance: true,
  functional: false,
  advertising: false,
};
